import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/content";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-20 md:py-28 border-y border-gray-200/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
            Our Process
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-bold font-heading tracking-tight text-[#0F2D52]">
            A clear, structured advisory journey
          </h2>
          <p className="mt-3 text-sm text-gray-600">
            Money Mart facilitates the process. Final approval rests solely with the lender.
          </p>
        </div>

        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#1E5AA8]/30 to-transparent" />

          <div className="space-y-8">
            {PROCESS_STEPS.map((s, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  data-testid={`process-step-${i}`}
                  className={`relative flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 ${
                    left ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  <div className="hidden md:block md:w-1/2" />
                  <div className="absolute left-4 md:left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-[#0F2D52] text-white text-xs font-bold flex items-center justify-center ring-4 ring-[#F8FAFC] shadow-[0_4px_12px_rgba(15,45,82,0.25)]">
                    {i + 1}
                  </div>
                  <div className="pl-14 md:pl-0 md:w-1/2">
                    <div className="rounded-2xl bg-white border border-gray-200 p-5 shadow-[0_4px_16px_rgba(15,45,82,0.05)]">
                      <h3 className="text-base md:text-lg font-bold font-heading text-[#0F2D52] tracking-tight">
                        {s.title}
                      </h3>
                      <p className="mt-1 text-sm text-gray-600 leading-relaxed">
                        {s.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
